export enum PropertyFeaturesAndAmenityTabModalsEnum {
  MANAGE_AMENITIES_MODAL = 'MANAGE_AMENITIES_MODAL',
  REMOVE_AMENITY_MODAL = 'REMOVE_AMENITY_MODAL',
  EDIT_AMENITY_NAME_IN_PROPERTY_MODAL = 'EDIT_AMENITY_NAME_IN_PROPERTY_MODAL',
}
